namespace Solovis.Site.Search {

  // TODO there are identical enums in:
  // - InvData/InvData.Services/Search/UniversalSearchService.cs
  // - portfolio-ui/libs/pa/utils/src/lib/data/search.ts
  // Find a way to consolidate to just 1 or 2 copies?
  enum SearchCategories {
    All = 0,
    Entities = 1,
    Investments = 2,
    Reports = 3,
    Tags = 4,
    Managers = 5,
  }
  type SearchKey = keyof typeof SearchCategories;

  export class ExtendedSearchResultsControl extends Solovis.UI.BaseControl {

    public _query: any;
    private _itemToggles: Omit<Record<SearchKey, boolean>, "All">;
    public _showAll: boolean;
    public _extendedSearchResultsData: any;
    public _initErrorText: any;

    public _filterListControl: Solovis.UI.StringFilterListControl;

    private _focusAfterRender: boolean;

    private _toggleButtonGroupContainerDiv;
    private _availableHeight;

    constructor(options) {
      super(options);

      var self = this;

      if (!options.query) {
        throw "Solovis.Site.Search.ExtendedSearchResultsControl Missing Parameter: query";
      }

      this._query = options.query;

      this._itemToggles = {
        Entities: false,
        Investments: false,
        Managers: false,
        Tags: false,
        Reports: false,
      };

      if (!options.query.category || options.query.category === SearchCategories.All) {
        this._showAll = true;
      } else {
        this._showAll = false;
        switch (options.query.category) {
          case SearchCategories.Entities: {
            this._itemToggles.Entities = true;
            break;
          }
          case SearchCategories.Investments: {
            this._itemToggles.Investments = true;
            break;
          }
          case SearchCategories.Managers: {
            this._itemToggles.Managers = true;
            break;
          }
          case SearchCategories.Tags: {
            this._itemToggles.Tags = true;
            break;
          }
          case SearchCategories.Reports: {
            this._itemToggles.Reports = true;
            break;
          }
          default: {
            this._showAll = true;
            break;
          }
        }
      }
      this._query.excludeDemotedItems = false;

      this._focusAfterRender = false;
    }

    public doInitAsync() {
      this.findItems();
    }

    public findItems() {
      var self = this;

      // NOTE: we constrain itemToggles to only have one or no items that are true
      const categoryKey = (Object.keys(this._itemToggles) as Array<keyof typeof this._itemToggles>).filter(toggle => this._itemToggles[toggle])[0] || "All";
      const category = SearchCategories[categoryKey];

      var options = {
        query: {
          filterText: this._query.filterText,
          category: category,
          excludeDemotedItems: this._query.excludeDemotedItems,
        },
        offset: 0,
        maxItems: Solovis.Site.Search.maxItemsInExtendedSearchResultsDialog
      };

      Solovis.Rpc.invoke("~/Search/FindItems", options,
        function (response, success) {
          if (success) {
            self._extendedSearchResultsData = response.result.data;
            if (self._filterListControl) {
              self._filterListControl.setListItems(self._extendedSearchResultsData);
            }
            self.notifyInitComplete();
          }
          else {
            self._initErrorText = response.error.message;
            self.notifyInitComplete();
          }
        });
    }

    public doRender() {
      var self = this;

      if (this._initErrorText) {
        this.container.text(this._initErrorText);
        return;
      }

      this._createToggleButtons();

      var itemFilter = function (itemList: Array<Solovis.Portal.UnifiedSearchService.SearchResult>, filterOptions: { queryText: string }) {
        var resultList: Array<{
          isPrefix: boolean;
          item: Solovis.Portal.UnifiedSearchService.SearchResult;
          labelLower: string;
        }> = [];

        var queryTextLower = filterOptions.queryText.toLowerCase();

        itemList.forEach(item => {

          if (self._showAll ||
            self._itemToggles.Entities && 'entityId' in item ||
            self._itemToggles.Investments && 'investmentId' in item ||
            self._itemToggles.Managers && 'managerId' in item ||
            self._itemToggles.Tags && 'tagId' in item ||
            self._itemToggles.Reports && 'reportDefinitionId' in item
          ) {
            var labelLower = item.label.toLowerCase();
            var labelMatch = labelLower.indexOf(queryTextLower);


            if (labelMatch !== -1) {
              resultList.push({
                isPrefix: labelMatch === 0,
                item: item,
                labelLower: labelLower
              });
            }
          }
        });

        return resultList;
      }

      var itemDivGenerator = function (itemHolder, filterOptions) {
        var itemDiv = $("<div>")
          .css({
            "white-space": "nowrap",
            "overflow": "hidden",
            "text-overflow": "ellipsis"
          })
          .text(itemHolder.item.label);

        const iconPadding = { "padding-right": "10px" };
        if (itemHolder.item.entityId) {
          Solovis.UI.Icons.createEntityIcon(iconPadding).prependTo(itemDiv);
        }
        else if (itemHolder.item.investmentId) {
          Solovis.UI.Icons.createInvestmentIcon({
            "left": "-2px",
            "padding-right": "4px"
          })
            .prependTo(itemDiv);
        }
        else if (itemHolder.item.tagId) {
          Solovis.UI.Icons.createTagIcon(iconPadding).prependTo(itemDiv);
        }
        else if (itemHolder.item.managerId) {
          Solovis.UI.Icons.createManagerIcon(iconPadding).prependTo(itemDiv);
        }
        else if (itemHolder.item.reportDefinitionId) {
          Solovis.UI.Icons.createReportIcon(iconPadding).prependTo(itemDiv);
        }
        else if (itemHolder.item.contactId) {
          Solovis.UI.Icons.createContactIcon(iconPadding).prependTo(itemDiv);
        }
        else if (itemHolder.item.userId) {
          Solovis.UI.Icons.createUserIcon(iconPadding).prependTo(itemDiv);
        }
        else {
          // If none of these conditions are true, just add a transparent spacer so things line up
          $("<span>")
            .css("padding-right", "10px")
            .css("color", "transparent")
            .addClass("fa fa-circle").prependTo(itemDiv);
        }

        return itemDiv;
      }

      var selectorControlHostDiv = $("<div>")
        .addClass("solovis-input")
        .appendTo(this.container);

      this._filterListControl = new Solovis.UI.StringFilterListControl({
        controlHost: selectorControlHostDiv,
        listItems: this._extendedSearchResultsData,
        listFilter: itemFilter,
        itemDivGenerator: itemDivGenerator
      });

      $(this._filterListControl)
        .on("selectionChanged", function (e, data) {
          var selectedItem = data.item;
          Solovis.Portal.UnifiedSearchService.selectionHandler(selectedItem);
          $(self).trigger("selectionChanged");
        })
        .on("renderComplete", function () {
          if (self._availableHeight) {
            self.setAvailableHeight(self._availableHeight);
            self._availableHeight = null;
          }
        });

      this._filterListControl.setAsCurrentControl();

      if (this._focusAfterRender) {
        this.focusFilter();
      }
    }

    public _createToggleButtons() {
      var self = this;

      const filterGroupContainer = $("<div>")
        .css({
          "display": "flex",
          "place-items": "center",
        })
        .appendTo(this.container);

      this._toggleButtonGroupContainerDiv = $("<div>")
        .css("padding", "5px")
        .addClass("btn-group")
        .attr("data-toggle", "buttons")
        .appendTo(filterGroupContainer);


      const toggleCheckboxes: Record<keyof typeof self._itemToggles, JQuery | undefined> = {
        Entities: undefined,
        Investments: undefined,
        Tags: undefined,
        Reports: undefined,
        Managers: undefined,
      };

      const iconPadding = { "padding-right": "5px" };
      // #region Toggle Entities
      const entitiesButtonLabel = $("<label>")
        .addClass("btn btn-primary btn-xs")
        .appendTo(this._toggleButtonGroupContainerDiv);

      Solovis.UI.Icons.createEntityIcon(iconPadding)
        .appendTo(entitiesButtonLabel);
      entitiesButtonLabel.append("Entities");

      toggleCheckboxes.Entities = $("<input>")
        .attr("type", "checkbox")
        .prop("value", SearchCategories[SearchCategories.Entities])
        .prop("name", "itemToggles")
        .appendTo(entitiesButtonLabel);

      if (self._itemToggles.Entities) {
        toggleCheckboxes.Entities.prop("checked", true);
        entitiesButtonLabel.toggleClass("active");
      }
      // #endregion

      // #region Toggle Investments
      const investmentsButtonLabel = $("<label>")
        .css("padding", "1px")
        .addClass("btn btn-primary btn-xs")
        .appendTo(this._toggleButtonGroupContainerDiv);

      Solovis.UI.Icons.createInvestmentIcon(iconPadding).appendTo(investmentsButtonLabel);
      investmentsButtonLabel.append("Investments");

      toggleCheckboxes.Investments = $("<input>")
        .attr("type", "checkbox")
        .prop("value", SearchCategories[SearchCategories.Investments])
        .prop("name", "itemToggles")
        .appendTo(investmentsButtonLabel);

      if (self._itemToggles.Investments) {
        toggleCheckboxes.Investments.prop("checked", true);
        investmentsButtonLabel.toggleClass("active");
      }
      // #endregion

      // #region Toggle Managers
      const managersButtonLabel = $("<label>")
        .addClass("btn btn-primary btn-xs")
        .appendTo(this._toggleButtonGroupContainerDiv);

      Solovis.UI.Icons.createManagerIcon(iconPadding).appendTo(managersButtonLabel);
      managersButtonLabel.append("Managers");

      toggleCheckboxes.Managers = $("<input>")
        .attr("type", "checkbox")
        .prop("value", SearchCategories[SearchCategories.Managers])
        .prop("name", "itemToggles")
        .appendTo(managersButtonLabel);

      if (self._itemToggles.Managers) {
        toggleCheckboxes.Managers.prop("checked", true);
        managersButtonLabel.toggleClass("active");
      }
      // #endregion

      // #region Toggle Tags
      const tagsButtonLabel = $("<label>")
        .addClass("btn btn-primary btn-xs")
        .appendTo(this._toggleButtonGroupContainerDiv);


      Solovis.UI.Icons.createTagsIcon({ "left": "-1px", ...iconPadding }).appendTo(tagsButtonLabel);
      tagsButtonLabel.append("Tags");

      toggleCheckboxes.Tags = $("<input>")
        .attr("type", "checkbox")
        .prop("value", SearchCategories[SearchCategories.Tags])
        .prop("name", "itemToggles")
        .appendTo(tagsButtonLabel);

      if (self._itemToggles.Tags) {
        toggleCheckboxes.Tags.prop("checked", true);
        tagsButtonLabel.toggleClass("active");
      }
      // #endregion

      // #region Toggle Reports
      const reportsButtonLabel = $("<label>")
        .addClass("btn btn-primary btn-xs")
        .appendTo(this._toggleButtonGroupContainerDiv);

      Solovis.UI.Icons.createReportIcon(iconPadding).appendTo(reportsButtonLabel);
      reportsButtonLabel.append("Reports");

      toggleCheckboxes.Reports = $("<input>")
        .attr("type", "checkbox")
        .prop("value", SearchCategories[SearchCategories.Reports])
        .prop("name", "itemToggles")
        .appendTo(reportsButtonLabel);

      if (self._itemToggles.Reports) {
        toggleCheckboxes.Reports.prop("checked", true);
        reportsButtonLabel.toggleClass("active");
      }
      // #endregion

      // #region Exclude Demoted Items
      const excludeDemotedItemsCheckBox = $("<input>")
        .attr("type", "checkbox")
        .css("margin", "0 4px")
        .prop("id", "excludeDemotedItemCheckBox")
        .appendTo(filterGroupContainer);

      const excludeDemotedItemsLabel = $("<label>")
        .text("Exclude Inactive Items")
        .css({ "margin": "0", "font-weight": "normal" })
        .prop("for", "excludeDemotedItemCheckBox")
        .appendTo(filterGroupContainer);

      if (this._query.excludeDemotedItems) {
        excludeDemotedItemsCheckBox.prop("checked", this._query.excludeDemotedItems === true);
      }

      $(excludeDemotedItemsCheckBox).change(function () {
        self._query.excludeDemotedItems = $(this).is(":checked");
        self.findItems();
      });
      // #endregion


      this._toggleButtonGroupContainerDiv.find("input:checkbox").change(function (e) {
        const input = $(this);
        const toggle = input.prop("value");

        // Clear other toggles from the object for filter
        for (const key of Object.keys(self._itemToggles)) {
          if (key === toggle) continue;
          self._itemToggles[key] = false;
        }
        // Clear other toggles from object for the checkboxes
        for (const key of Object.keys(toggleCheckboxes)) {
          if (key === toggle) continue;
          toggleCheckboxes[key].prop("checked", false);
          toggleCheckboxes[key].parent("label").removeClass("active");
        }

        // Set the toggle to current state
        self._itemToggles[toggle] = input.is(":checked");
        self._applyFilter();
      });
    }

    public _applyFilter() {
      var self = this;

      this._showAll =
        _.all(this._itemToggles, function (value) { return value === true; }) ||
        _.all(this._itemToggles, function (value) { return value === false; });

      // Get items related to filter
      this.findItems();
    }

    public setAvailableHeight(overallHeight) {
      var self = this;
      var availableHeight = overallHeight;

      if (this._toggleButtonGroupContainerDiv) {
        availableHeight = overallHeight - this._toggleButtonGroupContainerDiv.outerHeight();
      }

      if (this.state === Solovis.UI.BaseControl.ControlState.afterRender) {
        this._filterListControl.setAvailableHeight(availableHeight);
      }
      else {
        // The control is still rendering, so we will store the overallHeight and defer until the render is complete
        this._availableHeight = availableHeight;
      }
    }

    public focusFilter() {
      if (this._filterListControl) {
        this._filterListControl.focusFilter();
        this._focusAfterRender = false;
      }
      else {
        this._focusAfterRender = true;
      }
    }
  }
}
